import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHTML from '../../helper/to_dangerous_react_html';

class Tooltip extends React.Component {
    componentDidMount() {
        $(this.refs.container).tooltipster({
            contentAsHTML: true,
            content: this.props.content,
            interactive: true
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        $(this.refs.container).tooltipster('content', nextProps.content);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.content !== this.props.content;
    }

    render() {
        const containerClassNames = ['tooltip-init']
            .concat(this.props.additionalClassNames)
            .concat(this.props.label || this.props.children ? [] : ['tooltip-init--default-label'])
            .join(' ');

        const hintClassNames = ['tooltip-hint']
            .concat(this.props.additionalHintClassNames)
            .concat(this.props.attention ? ['tooltip-init--attention'] : [])
            .join(' ');

        return (
            <span
                className={containerClassNames}
                {...this.props.additionalAttributes}
                ref="container"
            >
                {
                    this.props.label
                        ? <span
                            className={hintClassNames}
                            onMouseEnter={this.props.onShowToolTip}
                            dangerouslySetInnerHTML={toDangerousReactHTML(this.props.label)}
                        />
                        : this.props.children
                            ? (
                                <span
                                    className={hintClassNames}
                                    onMouseEnter={this.props.onShowToolTip}
                                >
                                    {this.props.children}
                                </span>
                            )
                            : (
                                <span
                                    onMouseEnter={this.props.onShowToolTip}
                                    className={hintClassNames}
                                >
                                    {
                                        this.props.attention
                                            ? '!'
                                            : '?'
                                    }
                                </span>
                            )
                }
            </span>
        );
    }
}

Tooltip.propTypes = {
    content: PropTypes.string.isRequired,
    label: PropTypes.string,
    additionalClassNames: PropTypes.array,
    additionalHintClassNames: PropTypes.array,
    additionalAttributes: PropTypes.object,
    onShowToolTip: PropTypes.func,
    attention: PropTypes.bool,
};

Tooltip.defaultProps = {
    additionalClassNames: [],
    additionalHintClassNames: [],
    additionalAttributes: {},
    onShowToolTip: undefined,
    attention: false,
};

export default Tooltip;
